/* eslint-disable */

export interface AssetIdentifier {
  /**
   *  optional identifier for the asset e.g. file ID, hash of the content
   */
  id?: string | undefined;
  type: AssetType;
}

export interface BaseAsset {
  assetId: AssetId | undefined;
  mediaType: BaseAsset_MediaType;
  assetType: AssetType;
}

export interface AssetId {
  id: string;
  identifierType: AssetId_IdentifierType;
}

const baseAssetIdentifier: object = {
  type: 0,
};

const baseBaseAsset: object = {
  mediaType: 0,
  assetType: 0,
};

const baseAssetId: object = {
  id: '',
  identifierType: 0,
};

export const protobufPackage = 'spotify.catalogmanagement.entity.v1';

/**  init version copied from https://ghe.spotify.net/catalog-management/case-management-proto/blob/master/src/main/resources/spotify/casemanagement/v1/lead.proto
 */
export enum AssetType {
  UNKNOWN_ASSET_TYPE = 0,
  IMAGE = 1,
  AUDIO = 2,
  CANVAS_ASSET = 3,
  STORYLINE = 4,
  DESCRIPTION = 5,
  TITLE = 6,
  BIOGRAPHY = 7,
  ARTIST_PICK_TEXT = 8,
  ARTIST_PICK_IMAGE = 9,
  PROFILE_IMAGE = 10,
  BANNER_IMAGE = 11,
  /** GALLERY_IMAGE -   Use ARTIST_GALLERY for entire gallery or  ARTIST_GALLERY_IMAGE for single image from gallery
   */
  GALLERY_IMAGE = 12,
  USER_PROFILE_LOCKERROOM = 13,
  USER_PROFILE_SPOTIFY = 14,
  ARTIST_MERCHANDISE = 15,
  VIDEO = 16,
  SUBTITLE = 17,
  CHAT = 18,
  COMMENT_ASSET = 19,
  USER_PROFILE_NAME = 20,
  ROOM_TEXT = 21,
  ALL = 22,
  NOT_SPECIFIED = 23,
  PLAYLIST_IMAGE = 24,
  PROFILE_NAME = 25,
  POLL_QUESTION_TEXT = 26,
  POLL_OPTIONS_TEXT = 27,
  QUESTION_TEXT = 28,
  RESPONSE_TEXT = 29,
  CANVAS_IMAGE = 30,
  CANVAS_VIDEO = 31,
  MERCH_TITLE = 32,
  MERCH_DESCRIPTION = 33,
  MERCH_IMAGE_GALLERY = 34,
  ARTIST_PICK = 35,
  ARTIST_AVATAR = 36,
  ARTIST_HEADER = 38,
  ARTIST_BIOGRAPHY = 39,
  ARTIST_FAN_SUPPORT = 40,
  ARTIST_GALLERY = 41,
  COMMENT_TEXT = 42,
  /** EXPRESSION_VIDEO -  We will not use expression as a generic type
   */
  EXPRESSION_VIDEO = 43,
  /** EXPRESSION_IMAGE -  We will not use expression as a generic type
   */
  EXPRESSION_IMAGE = 44,
  CHAT_MESSAGE_TEXT = 45,
  TRANSCRIPT_TEXT = 46,
  SUPPLEMENTARY_PDF = 47,
  PODCAST_THUMBNAIL_IMAGE = 48,
  EPISODE_VIDEO_PREVIEW_VIDEO = 49,
  EPISODE_VIDEO_PREVIEW_AUDIO = 50,
  ALBUM_AUDIO = 51,
  ALBUM_COVER_ART_IMAGE = 52,
  EPISODE_AUDIO = 53,
  TRACK_AUDIO = 54,
  EPISODE_VIDEO_PREVIEW_TITLE = 55,
  ARTIST_GALLERY_IMAGE = 56,
}

export function assetTypeFromJSON(object: any): AssetType {
  switch (object) {
    case 0:
    case 'UNKNOWN_ASSET_TYPE':
      return AssetType.UNKNOWN_ASSET_TYPE;
    case 1:
    case 'IMAGE':
      return AssetType.IMAGE;
    case 2:
    case 'AUDIO':
      return AssetType.AUDIO;
    case 3:
    case 'CANVAS_ASSET':
      return AssetType.CANVAS_ASSET;
    case 4:
    case 'STORYLINE':
      return AssetType.STORYLINE;
    case 5:
    case 'DESCRIPTION':
      return AssetType.DESCRIPTION;
    case 6:
    case 'TITLE':
      return AssetType.TITLE;
    case 7:
    case 'BIOGRAPHY':
      return AssetType.BIOGRAPHY;
    case 8:
    case 'ARTIST_PICK_TEXT':
      return AssetType.ARTIST_PICK_TEXT;
    case 9:
    case 'ARTIST_PICK_IMAGE':
      return AssetType.ARTIST_PICK_IMAGE;
    case 10:
    case 'PROFILE_IMAGE':
      return AssetType.PROFILE_IMAGE;
    case 11:
    case 'BANNER_IMAGE':
      return AssetType.BANNER_IMAGE;
    case 12:
    case 'GALLERY_IMAGE':
      return AssetType.GALLERY_IMAGE;
    case 13:
    case 'USER_PROFILE_LOCKERROOM':
      return AssetType.USER_PROFILE_LOCKERROOM;
    case 14:
    case 'USER_PROFILE_SPOTIFY':
      return AssetType.USER_PROFILE_SPOTIFY;
    case 15:
    case 'ARTIST_MERCHANDISE':
      return AssetType.ARTIST_MERCHANDISE;
    case 16:
    case 'VIDEO':
      return AssetType.VIDEO;
    case 17:
    case 'SUBTITLE':
      return AssetType.SUBTITLE;
    case 18:
    case 'CHAT':
      return AssetType.CHAT;
    case 19:
    case 'COMMENT_ASSET':
      return AssetType.COMMENT_ASSET;
    case 20:
    case 'USER_PROFILE_NAME':
      return AssetType.USER_PROFILE_NAME;
    case 21:
    case 'ROOM_TEXT':
      return AssetType.ROOM_TEXT;
    case 22:
    case 'ALL':
      return AssetType.ALL;
    case 23:
    case 'NOT_SPECIFIED':
      return AssetType.NOT_SPECIFIED;
    case 24:
    case 'PLAYLIST_IMAGE':
      return AssetType.PLAYLIST_IMAGE;
    case 25:
    case 'PROFILE_NAME':
      return AssetType.PROFILE_NAME;
    case 26:
    case 'POLL_QUESTION_TEXT':
      return AssetType.POLL_QUESTION_TEXT;
    case 27:
    case 'POLL_OPTIONS_TEXT':
      return AssetType.POLL_OPTIONS_TEXT;
    case 28:
    case 'QUESTION_TEXT':
      return AssetType.QUESTION_TEXT;
    case 29:
    case 'RESPONSE_TEXT':
      return AssetType.RESPONSE_TEXT;
    case 30:
    case 'CANVAS_IMAGE':
      return AssetType.CANVAS_IMAGE;
    case 31:
    case 'CANVAS_VIDEO':
      return AssetType.CANVAS_VIDEO;
    case 32:
    case 'MERCH_TITLE':
      return AssetType.MERCH_TITLE;
    case 33:
    case 'MERCH_DESCRIPTION':
      return AssetType.MERCH_DESCRIPTION;
    case 34:
    case 'MERCH_IMAGE_GALLERY':
      return AssetType.MERCH_IMAGE_GALLERY;
    case 35:
    case 'ARTIST_PICK':
      return AssetType.ARTIST_PICK;
    case 36:
    case 'ARTIST_AVATAR':
      return AssetType.ARTIST_AVATAR;
    case 38:
    case 'ARTIST_HEADER':
      return AssetType.ARTIST_HEADER;
    case 39:
    case 'ARTIST_BIOGRAPHY':
      return AssetType.ARTIST_BIOGRAPHY;
    case 40:
    case 'ARTIST_FAN_SUPPORT':
      return AssetType.ARTIST_FAN_SUPPORT;
    case 41:
    case 'ARTIST_GALLERY':
      return AssetType.ARTIST_GALLERY;
    case 42:
    case 'COMMENT_TEXT':
      return AssetType.COMMENT_TEXT;
    case 43:
    case 'EXPRESSION_VIDEO':
      return AssetType.EXPRESSION_VIDEO;
    case 44:
    case 'EXPRESSION_IMAGE':
      return AssetType.EXPRESSION_IMAGE;
    case 45:
    case 'CHAT_MESSAGE_TEXT':
      return AssetType.CHAT_MESSAGE_TEXT;
    case 46:
    case 'TRANSCRIPT_TEXT':
      return AssetType.TRANSCRIPT_TEXT;
    case 47:
    case 'SUPPLEMENTARY_PDF':
      return AssetType.SUPPLEMENTARY_PDF;
    case 48:
    case 'PODCAST_THUMBNAIL_IMAGE':
      return AssetType.PODCAST_THUMBNAIL_IMAGE;
    case 49:
    case 'EPISODE_VIDEO_PREVIEW_VIDEO':
      return AssetType.EPISODE_VIDEO_PREVIEW_VIDEO;
    case 50:
    case 'EPISODE_VIDEO_PREVIEW_AUDIO':
      return AssetType.EPISODE_VIDEO_PREVIEW_AUDIO;
    case 51:
    case 'ALBUM_AUDIO':
      return AssetType.ALBUM_AUDIO;
    case 52:
    case 'ALBUM_COVER_ART_IMAGE':
      return AssetType.ALBUM_COVER_ART_IMAGE;
    case 53:
    case 'EPISODE_AUDIO':
      return AssetType.EPISODE_AUDIO;
    case 54:
    case 'TRACK_AUDIO':
      return AssetType.TRACK_AUDIO;
    case 55:
    case 'EPISODE_VIDEO_PREVIEW_TITLE':
      return AssetType.EPISODE_VIDEO_PREVIEW_TITLE;
    case 56:
    case 'ARTIST_GALLERY_IMAGE':
      return AssetType.ARTIST_GALLERY_IMAGE;
    default:
      throw new globalThis.Error('Unrecognized enum value ' + object + ' for enum AssetType');
  }
}

export function assetTypeToJSON(object: AssetType): string {
  switch (object) {
    case AssetType.UNKNOWN_ASSET_TYPE:
      return 'UNKNOWN_ASSET_TYPE';
    case AssetType.IMAGE:
      return 'IMAGE';
    case AssetType.AUDIO:
      return 'AUDIO';
    case AssetType.CANVAS_ASSET:
      return 'CANVAS_ASSET';
    case AssetType.STORYLINE:
      return 'STORYLINE';
    case AssetType.DESCRIPTION:
      return 'DESCRIPTION';
    case AssetType.TITLE:
      return 'TITLE';
    case AssetType.BIOGRAPHY:
      return 'BIOGRAPHY';
    case AssetType.ARTIST_PICK_TEXT:
      return 'ARTIST_PICK_TEXT';
    case AssetType.ARTIST_PICK_IMAGE:
      return 'ARTIST_PICK_IMAGE';
    case AssetType.PROFILE_IMAGE:
      return 'PROFILE_IMAGE';
    case AssetType.BANNER_IMAGE:
      return 'BANNER_IMAGE';
    case AssetType.GALLERY_IMAGE:
      return 'GALLERY_IMAGE';
    case AssetType.USER_PROFILE_LOCKERROOM:
      return 'USER_PROFILE_LOCKERROOM';
    case AssetType.USER_PROFILE_SPOTIFY:
      return 'USER_PROFILE_SPOTIFY';
    case AssetType.ARTIST_MERCHANDISE:
      return 'ARTIST_MERCHANDISE';
    case AssetType.VIDEO:
      return 'VIDEO';
    case AssetType.SUBTITLE:
      return 'SUBTITLE';
    case AssetType.CHAT:
      return 'CHAT';
    case AssetType.COMMENT_ASSET:
      return 'COMMENT_ASSET';
    case AssetType.USER_PROFILE_NAME:
      return 'USER_PROFILE_NAME';
    case AssetType.ROOM_TEXT:
      return 'ROOM_TEXT';
    case AssetType.ALL:
      return 'ALL';
    case AssetType.NOT_SPECIFIED:
      return 'NOT_SPECIFIED';
    case AssetType.PLAYLIST_IMAGE:
      return 'PLAYLIST_IMAGE';
    case AssetType.PROFILE_NAME:
      return 'PROFILE_NAME';
    case AssetType.POLL_QUESTION_TEXT:
      return 'POLL_QUESTION_TEXT';
    case AssetType.POLL_OPTIONS_TEXT:
      return 'POLL_OPTIONS_TEXT';
    case AssetType.QUESTION_TEXT:
      return 'QUESTION_TEXT';
    case AssetType.RESPONSE_TEXT:
      return 'RESPONSE_TEXT';
    case AssetType.CANVAS_IMAGE:
      return 'CANVAS_IMAGE';
    case AssetType.CANVAS_VIDEO:
      return 'CANVAS_VIDEO';
    case AssetType.MERCH_TITLE:
      return 'MERCH_TITLE';
    case AssetType.MERCH_DESCRIPTION:
      return 'MERCH_DESCRIPTION';
    case AssetType.MERCH_IMAGE_GALLERY:
      return 'MERCH_IMAGE_GALLERY';
    case AssetType.ARTIST_PICK:
      return 'ARTIST_PICK';
    case AssetType.ARTIST_AVATAR:
      return 'ARTIST_AVATAR';
    case AssetType.ARTIST_HEADER:
      return 'ARTIST_HEADER';
    case AssetType.ARTIST_BIOGRAPHY:
      return 'ARTIST_BIOGRAPHY';
    case AssetType.ARTIST_FAN_SUPPORT:
      return 'ARTIST_FAN_SUPPORT';
    case AssetType.ARTIST_GALLERY:
      return 'ARTIST_GALLERY';
    case AssetType.COMMENT_TEXT:
      return 'COMMENT_TEXT';
    case AssetType.EXPRESSION_VIDEO:
      return 'EXPRESSION_VIDEO';
    case AssetType.EXPRESSION_IMAGE:
      return 'EXPRESSION_IMAGE';
    case AssetType.CHAT_MESSAGE_TEXT:
      return 'CHAT_MESSAGE_TEXT';
    case AssetType.TRANSCRIPT_TEXT:
      return 'TRANSCRIPT_TEXT';
    case AssetType.SUPPLEMENTARY_PDF:
      return 'SUPPLEMENTARY_PDF';
    case AssetType.PODCAST_THUMBNAIL_IMAGE:
      return 'PODCAST_THUMBNAIL_IMAGE';
    case AssetType.EPISODE_VIDEO_PREVIEW_VIDEO:
      return 'EPISODE_VIDEO_PREVIEW_VIDEO';
    case AssetType.EPISODE_VIDEO_PREVIEW_AUDIO:
      return 'EPISODE_VIDEO_PREVIEW_AUDIO';
    case AssetType.ALBUM_AUDIO:
      return 'ALBUM_AUDIO';
    case AssetType.ALBUM_COVER_ART_IMAGE:
      return 'ALBUM_COVER_ART_IMAGE';
    case AssetType.EPISODE_AUDIO:
      return 'EPISODE_AUDIO';
    case AssetType.TRACK_AUDIO:
      return 'TRACK_AUDIO';
    case AssetType.EPISODE_VIDEO_PREVIEW_TITLE:
      return 'EPISODE_VIDEO_PREVIEW_TITLE';
    case AssetType.ARTIST_GALLERY_IMAGE:
      return 'ARTIST_GALLERY_IMAGE';
    default:
      return 'UNKNOWN';
  }
}

export enum BaseAsset_MediaType {
  UNKNOWN_MEDIA_TYPE = 0,
  IMAGE = 1,
  AUDIO = 2,
  TEXT = 3,
  FILE = 4,
  VIDEO = 5,
}

export function baseAsset_MediaTypeFromJSON(object: any): BaseAsset_MediaType {
  switch (object) {
    case 0:
    case 'UNKNOWN_MEDIA_TYPE':
      return BaseAsset_MediaType.UNKNOWN_MEDIA_TYPE;
    case 1:
    case 'IMAGE':
      return BaseAsset_MediaType.IMAGE;
    case 2:
    case 'AUDIO':
      return BaseAsset_MediaType.AUDIO;
    case 3:
    case 'TEXT':
      return BaseAsset_MediaType.TEXT;
    case 4:
    case 'FILE':
      return BaseAsset_MediaType.FILE;
    case 5:
    case 'VIDEO':
      return BaseAsset_MediaType.VIDEO;
    default:
      throw new globalThis.Error('Unrecognized enum value ' + object + ' for enum BaseAsset_MediaType');
  }
}

export function baseAsset_MediaTypeToJSON(object: BaseAsset_MediaType): string {
  switch (object) {
    case BaseAsset_MediaType.UNKNOWN_MEDIA_TYPE:
      return 'UNKNOWN_MEDIA_TYPE';
    case BaseAsset_MediaType.IMAGE:
      return 'IMAGE';
    case BaseAsset_MediaType.AUDIO:
      return 'AUDIO';
    case BaseAsset_MediaType.TEXT:
      return 'TEXT';
    case BaseAsset_MediaType.FILE:
      return 'FILE';
    case BaseAsset_MediaType.VIDEO:
      return 'VIDEO';
    default:
      return 'UNKNOWN';
  }
}

export enum AssetId_IdentifierType {
  UNKNOWN_IDENTIFIER_TYPE = 0,
  /** CDN_URL -  E.g: https://i.scdn.co/image/ab67616d00001e0200c2365a3d33f97819952ce7
   */
  CDN_URL = 1,
  /** OSID -  E.g: eda07ab5-d212-4141-aed5-4bf53adf0a5a
   */
  OSID = 2,
  /** MD5_HASH -  E.g: foYOSnKElRK70LtU1cLdVQ==
   */
  MD5_HASH = 3,
  /** TRANSCODING_FILE_ID -  E.g: ab67d88f00004909164d1abef66b7d3d4712788a
   */
  TRANSCODING_FILE_ID = 4,
  /** URI -  E.g: spotify:artist:0Had1Wvp2MukVL89Wlomwh
   */
  URI = 5,
}

export function assetId_IdentifierTypeFromJSON(object: any): AssetId_IdentifierType {
  switch (object) {
    case 0:
    case 'UNKNOWN_IDENTIFIER_TYPE':
      return AssetId_IdentifierType.UNKNOWN_IDENTIFIER_TYPE;
    case 1:
    case 'CDN_URL':
      return AssetId_IdentifierType.CDN_URL;
    case 2:
    case 'OSID':
      return AssetId_IdentifierType.OSID;
    case 3:
    case 'MD5_HASH':
      return AssetId_IdentifierType.MD5_HASH;
    case 4:
    case 'TRANSCODING_FILE_ID':
      return AssetId_IdentifierType.TRANSCODING_FILE_ID;
    case 5:
    case 'URI':
      return AssetId_IdentifierType.URI;
    default:
      throw new globalThis.Error('Unrecognized enum value ' + object + ' for enum AssetId_IdentifierType');
  }
}

export function assetId_IdentifierTypeToJSON(object: AssetId_IdentifierType): string {
  switch (object) {
    case AssetId_IdentifierType.UNKNOWN_IDENTIFIER_TYPE:
      return 'UNKNOWN_IDENTIFIER_TYPE';
    case AssetId_IdentifierType.CDN_URL:
      return 'CDN_URL';
    case AssetId_IdentifierType.OSID:
      return 'OSID';
    case AssetId_IdentifierType.MD5_HASH:
      return 'MD5_HASH';
    case AssetId_IdentifierType.TRANSCODING_FILE_ID:
      return 'TRANSCODING_FILE_ID';
    case AssetId_IdentifierType.URI:
      return 'URI';
    default:
      return 'UNKNOWN';
  }
}

export const AssetIdentifier = {
  fromJSON(object: any): AssetIdentifier {
    const message = { ...baseAssetIdentifier } as AssetIdentifier;
    if (object.id !== undefined && object.id !== null) {
      message.id = String(object.id);
    } else {
      message.id = undefined;
    }
    if (object.type !== undefined && object.type !== null) {
      message.type = assetTypeFromJSON(object.type);
    } else {
      message.type = 0;
    }
    return message;
  },
  fromPartial(object: DeepPartial<AssetIdentifier>): AssetIdentifier {
    const message = { ...baseAssetIdentifier } as AssetIdentifier;
    if (object.id !== undefined && object.id !== null) {
      message.id = object.id;
    } else {
      message.id = undefined;
    }
    if (object.type !== undefined && object.type !== null) {
      message.type = object.type;
    } else {
      message.type = 0;
    }
    return message;
  },
  toJSON(message: AssetIdentifier): unknown {
    const obj: any = {};
    message.id !== undefined && (obj.id = message.id);
    message.type !== undefined && (obj.type = assetTypeToJSON(message.type));
    return obj;
  },
};

export const BaseAsset = {
  fromJSON(object: any): BaseAsset {
    const message = { ...baseBaseAsset } as BaseAsset;
    if (object.assetId !== undefined && object.assetId !== null) {
      message.assetId = AssetId.fromJSON(object.assetId);
    } else {
      message.assetId = undefined;
    }
    if (object.mediaType !== undefined && object.mediaType !== null) {
      message.mediaType = baseAsset_MediaTypeFromJSON(object.mediaType);
    } else {
      message.mediaType = 0;
    }
    if (object.assetType !== undefined && object.assetType !== null) {
      message.assetType = assetTypeFromJSON(object.assetType);
    } else {
      message.assetType = 0;
    }
    return message;
  },
  fromPartial(object: DeepPartial<BaseAsset>): BaseAsset {
    const message = { ...baseBaseAsset } as BaseAsset;
    if (object.assetId !== undefined && object.assetId !== null) {
      message.assetId = AssetId.fromPartial(object.assetId);
    } else {
      message.assetId = undefined;
    }
    if (object.mediaType !== undefined && object.mediaType !== null) {
      message.mediaType = object.mediaType;
    } else {
      message.mediaType = 0;
    }
    if (object.assetType !== undefined && object.assetType !== null) {
      message.assetType = object.assetType;
    } else {
      message.assetType = 0;
    }
    return message;
  },
  toJSON(message: BaseAsset): unknown {
    const obj: any = {};
    message.assetId !== undefined && (obj.assetId = message.assetId ? AssetId.toJSON(message.assetId) : undefined);
    message.mediaType !== undefined && (obj.mediaType = baseAsset_MediaTypeToJSON(message.mediaType));
    message.assetType !== undefined && (obj.assetType = assetTypeToJSON(message.assetType));
    return obj;
  },
};

export const AssetId = {
  fromJSON(object: any): AssetId {
    const message = { ...baseAssetId } as AssetId;
    if (object.id !== undefined && object.id !== null) {
      message.id = String(object.id);
    } else {
      message.id = '';
    }
    if (object.identifierType !== undefined && object.identifierType !== null) {
      message.identifierType = assetId_IdentifierTypeFromJSON(object.identifierType);
    } else {
      message.identifierType = 0;
    }
    return message;
  },
  fromPartial(object: DeepPartial<AssetId>): AssetId {
    const message = { ...baseAssetId } as AssetId;
    if (object.id !== undefined && object.id !== null) {
      message.id = object.id;
    } else {
      message.id = '';
    }
    if (object.identifierType !== undefined && object.identifierType !== null) {
      message.identifierType = object.identifierType;
    } else {
      message.identifierType = 0;
    }
    return message;
  },
  toJSON(message: AssetId): unknown {
    const obj: any = {};
    message.id !== undefined && (obj.id = message.id);
    message.identifierType !== undefined && (obj.identifierType = assetId_IdentifierTypeToJSON(message.identifierType));
    return obj;
  },
};

type Builtin = Date | Function | Uint8Array | string | number | undefined;
type DeepPartial<T> = T extends Builtin
  ? T
  : T extends Array<infer U>
  ? Array<DeepPartial<U>>
  : T extends ReadonlyArray<infer U>
  ? ReadonlyArray<DeepPartial<U>>
  : T extends {}
  ? { [K in keyof T]?: DeepPartial<T[K]> }
  : Partial<T>;
